const GET_MANAGED_EQUIPMENT_DROP_DOWN = 'GET_MANAGED_EQUIPMENT_DROP_DOWN';
const SET_MANAGED_EQUIPMENT_DROP_DOWN = 'SET_MANAGED_EQUIPMENT_DROP_DOWN'

export
{
    GET_MANAGED_EQUIPMENT_DROP_DOWN,
    SET_MANAGED_EQUIPMENT_DROP_DOWN
};